import React from 'react'
import ReactDOM from 'react-dom/client'
// import TestApp from './TestApp.jsx'
import App from './App.jsx'
import './index.css'

console.log('🚀 Main: Starting CogniQ Frontend');
console.log('🔧 Main: Environment variables:', {
  API_URL: import.meta.env.VITE_API_BASE_URL,
  FIREBASE_PROJECT: import.meta.env.VITE_FIREBASE_PROJECT_ID
});

try {
  const rootElement = document.getElementById('root');
  console.log('🔍 Main: Root element:', rootElement);
  
  if (!rootElement) {
    throw new Error('Root element not found');
  }
  
  const root = ReactDOM.createRoot(rootElement);
  console.log('✅ Main: Root created, rendering app');
  
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  
  console.log('✅ Main: App rendered successfully');
} catch (error) {
  console.error('❌ Main: Failed to render app:', error);
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: Arial, sans-serif; background: #f0f0f0; min-height: 100vh;">
      <h1 style="color: red;">CogniQ - Loading Error</h1>
      <p>Failed to load the application. Please check the console for details.</p>
      <pre style="background: white; padding: 10px; border: 1px solid #ccc;">${error.message}</pre>
      <p><strong>Stack:</strong></p>
      <pre style="background: white; padding: 10px; border: 1px solid #ccc; font-size: 12px;">${error.stack}</pre>
    </div>
  `;
}